import { makeAutoObservable, runInAction } from 'mobx';

// Хотелось бы использовать этот стор во всем проекте, вместо текущей реализации.
export class UserStore {
  constructor(rootStore) {
    this.rootStore = rootStore;

    this.currentUser = null;

    makeAutoObservable(this);
  }

  getUser = async () => {
    const res = await this.rootStore.api.user.getCurrentUser();

    runInAction(() => {
      this.currentUser = res;
    });

    return res;
  };
}
